<div style="margin: 10px;">
    <ul class="nav nav-tabs" style="margin: 10px 0 15px 0">
        <li *ngFor="let item of menu_list;let i = index" class="nav-item"  style="cursor:pointer"  (click)="choose(item.id)">
            <span   [ngClass]="now==item.id?'active':''" class="nav-link" href="#">{{item.name}}</span>
        </li>
    </ul>
    <div class="container">
      <div *ngIf="now=='1'">
        <div [ngClass]="['status-card', points == 0 ? 'status-active' : 'status-banned']">
            <div class="status-icon">
                {{ points == 0 ? '✅' : '⏳' }}
            </div>
            <div class="status-text">
                <div class="status-title" [ngClass]="points == 0 ? 'text-green' : 'text-red'">
                    {{ points == 0 ? '狀態：非送審狀態' : '狀態：送審中' }}
                </div>
                <div class="status-message">
                    {{ points == 0 ? '您目前是上架狀態，功能正常使用' : '您目前是下架狀態，請等待審核' }}
                </div>
            </div>
            <div>
                <button
                    class="toggle-btn"
                    [ngClass]="points == 0 ? 'btn-green' : 'btn-red'"
                    (click)="toggleStatus()">
                    {{ points == 0 ? '送出審核下架' : '取消送審並上架' }}
                </button>
            </div>
        </div>

        <div class="appinfo-action-section mt-3" style="margin: 15px 0;">
            <button class="btn btn-success" style="margin-right: 10px;" (click)="setAppInfo(1)">
                啟用公告與背包道具
            </button>
            <button class="btn btn-danger" (click)="setAppInfo(0)">
                關閉公告與背包道具
            </button>
        </div>

        <!-- 添加 APK 上傳區域 -->
        <div class="apk-upload-section mt-4">
            <h4>上傳 APK 文件</h4>
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group">
                        <div class="btn btn-info" style="position:relative;">
                            <input style="opacity:0;width:100%;height:100%;position:absolute;left:0;top:0;"
                                   type="file" (change)="uploadApk($event)"
                                   placeholder="Upload APK" accept=".apk,.ipa">
                            點我上傳 APK
                        </div>
                        <small class="form-text text-muted" *ngIf="apkFileName">已選擇: {{apkFileName}}</small>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group" *ngIf="apkFileName">
                        <button class="btn btn-primary" (click)="submitApkUpload()">
                            <i class="fas fa-upload mr-1"></i> 上傳到伺服器
                        </button>
                    </div>
                    <div *ngIf="uploadProgress > 0 && uploadProgress < 100" class="progress mt-2">
                        <div class="progress-bar" [style.width.%]="uploadProgress">{{uploadProgress}}%</div>
                    </div>
                </div>
            </div>
        </div>
      </div>

        <app-appconfig *ngIf="now=='config'"></app-appconfig>

        <div *ngIf="now=='0'">
            00
        </div>
        <div *ngIf="now=='1'">
           <table class="table table-responsive-sm ">
            <tr  style="font-size: 18px;">
                <th ng-reflect-ng-class="width5percent" class="width5percent ng-star-inserted">系統</th>
                <th ng-reflect-ng-class="width5percent" class="width5percent ng-star-inserted">app版本號</th>
                <th ng-reflect-ng-class="width5percent" class="width5percent ng-star-inserted">管理app版本號</th>
                <th ng-reflect-ng-class="width5percent" class="width5percent ng-star-inserted">release_name</th>
                <th ng-reflect-ng-class="width5percent" class="width5percent ng-star-inserted">release_code</th>
                <th ng-reflect-ng-class="width5percent" class="width5percent ng-star-inserted">操作</th>
            </tr>
            <tr *ngIf="edit_data.android">
                <td>安卓</td>
                <td>{{edit_data.android[11].title}}</td>
                <td>{{edit_data.android[12].title}}</td>
                <td>{{edit_data.android[26].title}}</td>
                <td>{{edit_data.android[27].title}}</td>
                <td>
                    <a href="javascript:void(0)" (click)="edit_os='1'" title="點我設定"   data-toggle="modal" data-target=".bd-example-modal-xl">
                        <i style="margin: 0 10px 0 0;" class="fas fa-wrench"></i>
                    </a>
                </td>
            </tr>
            <tr *ngIf="edit_data.ios">
                <td>iOs</td>
                <td>{{edit_data.ios[2].title}}</td>
                <td>{{edit_data.ios[7].title}}</td>
                <td>{{edit_data.ios[28].title}}</td>
                <td>{{edit_data.ios[29].title}}</td>
                <td>
                    <a href="javascript:void(0)" (click)="edit_os='2'" title="點我設定"   data-toggle="modal" data-target=".bd-example-modal-xl">
                        <i style="margin: 0 10px 0 0;" class="fas fa-wrench"></i>
                    </a>
                </td>
            </tr>
           </table>
        </div>
    </div>
    <app-toast></app-toast>
    <div  class="modal fade bd-example-modal-xl" tabindex="-1" role="dialog"  data-keyboard="false" data-backdrop="static" aria-labelledby="myExtraLargeModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-xl">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 *ngIf="edit_os=='1'" class="modal-title">修改安卓版號</h5>
                    <h5 *ngIf="edit_os=='2'" class="modal-title">修改ios版號</h5>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body" *ngIf="edit_os=='1'">
                    <div class="user_edit_block">
                        app版號
                        <input type="text" (change)="check(edit_data.android[11].title,data.android[11].title,'app版號')" [(ngModel)]="data.android[11].title" class="form-control fix_input">
                        <div class="tips">當前版號:{{edit_data.android[11].title}}</div>
                    </div>
                    <div class="user_edit_block">
                        管理app版本號
                        <input type="text" (change)="check(edit_data.android[12].title,data.android[12].title,'管理app版號')" [(ngModel)]="data.android[12].title" class="form-control fix_input">
                        <div class="tips">當前版號:{{edit_data.android[12].title}}</div>
                    </div>
                    <div class="user_edit_block">
                        release_name
                        <input type="text" (change)="check(edit_data.android[26].title,data.android[26].title,'release_name')" [(ngModel)]="data.android[26].title" class="form-control fix_input">
                        <div class="tips">當前release_name:{{edit_data.android[26].title}}</div>
                    </div>
                    <div class="user_edit_block">
                        release_code
                        <input type="text" (change)="check(edit_data.android[27].title,data.android[27].title,'release_code')" [(ngModel)]="data.android[27].title" class="form-control fix_input">
                        <div class="tips">當前release_code:{{edit_data.android[27].title}}</div>
                    </div>
                </div>
                <div class="modal-body" *ngIf="edit_os=='2'">
                    <div class="user_edit_block">
                        app版號
                        <input type="text" (change)="check(edit_data.ios[2].title,data.ios[2].title,'app版號')" [(ngModel)]="data.ios[2].title" class="form-control fix_input">
                        <div class="tips">當前版號:{{edit_data.ios[2].title}}</div>
                    </div>
                    <div class="user_edit_block">
                        管理app版本號
                        <input type="text" (change)="check(edit_data.ios[7].title,data.ios[7].title,'管理app版號')" [(ngModel)]="data.ios[7].title" class="form-control fix_input">
                        <div class="tips">當前版號:{{edit_data.ios[7].title}}</div>
                    </div>
                    <div class="user_edit_block">
                        release_name
                        <input type="text" (change)="check(edit_data.ios[28].title,data.ios[28].title,'release_name')" [(ngModel)]="data.ios[28].title" class="form-control fix_input">
                        <div class="tips">當前版號:{{edit_data.ios[28].title}}</div>
                    </div>
                    <div class="user_edit_block">
                        release_code
                        <input type="text" (change)="check(edit_data.ios[29].title,data.ios[29].title,'release_code')" [(ngModel)]="data.ios[29].title" class="form-control fix_input">
                        <div class="tips">當前版號:{{edit_data.ios[29].title}}</div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button"  (click)="save()"  class="btn btn-primary" data-dismiss="modal">確認</button>
                    <button type="button"  (click)="init_list()"  class="btn btn-danger" data-dismiss="modal">取消</button>
                </div>
            </div>
        </div>
    </div>
</div>
<app-spinner [loading]="loading"></app-spinner>
